import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { MatRipple, MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from '../../../modules/shared/shared.module';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'ig-confirm-dialog',
  standalone: true,
  imports: [MatRipple, MatRippleModule, MatIconModule, SharedModule, CommonModule],
  templateUrl: './confirm.dialog.component.html',
  styleUrl: './confirm.dialog.component.scss',
  encapsulation: ViewEncapsulation.None,
  host: {
    class:
      'w-fit h-fit absolute z-[100] block rounded border border-[lightgray] bg-white py-3 px-4 text-gray-600 shadow-sm',
  },
})
export class ConfirmDialogComponent {
  @Input() triggerEl: ElementRef = null;
  @Input() isShowIcon = true;
  @Input() text = 'Are you sure?';
  @Input() isOperating = false;
  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();

  @ViewChild('dialog') dialogRef: ElementRef;

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    if (!this.dialogRef.nativeElement.contains(event.target)) {
      if (!this.triggerEl) {
        this.cancel.emit();
        return;
      }

      const nativeElement =
        this.triggerEl.nativeElement || this.triggerEl['_elementRef'].nativeElement;
      if (!nativeElement.contains(event.target)) {
        this.cancel.emit();
        return;
      }
    }
  }
}
